import React, {Component} from 'react';
import { connect} from "remx";

import Sidebar from './Sidebar';
import SectionDataView from '../../containers/_layout/SectionDataView';
import dataStore from '../../stores/data';
import DataTable from '../../components/DataTable';

class KlasifikasiPekerjaan extends Component {
  constructor(props) {
    super(props);

    this.options = {
      sortIndicator: true,
      hideSizePerPage: true,
      paginationSize: 6,
      hidePageListOnlyOnePage: true,
      clearSearch: true,
      alwaysShowAllBtns: false,
      withFirstAndLast: false
    }
    this.state = {
      reload:false,
      loading: false,
      id_pk_column: 'id',
      url: { url_get_data : '/data/pelanggan_klasifikasi', url_save_data: '/pelanggan', url_update_data: '/pelanggan', 
             url_delete_data: '/pelanggan', url_get_data_per: '/pelanggan' },
      title: 'Data Pekerjaan', 
      title_add : '', 
      columns: [
        { header: 'Kategori', id: 'kategori', accessor: 'kategori', child_accessor: null,
            Cell: row => {
                  return (row.value.substring(0, 25) + (row.value.length > 25 ? '.....' : ''))
            }
        },
        { header: 'Klasifikasi', id: 'klasifikasi', accessor: 'klasifikasi', child_accessor: null,
            Cell: row => {
                  return (row.value) ? (row.value.substring(0, 25) + (row.value.length > 25 ? '.....' : '')) : ''
            }
        },
        // { header: 'Nama', id: 'nama_pelanggan', accessor: 'nama_pelanggan', child_accessor: null, className: 'text-center'},
        { header: 'Nama', id: 'nama_pelanggan', accessor: 'nama_pelanggan', child_accessor: null,
            Cell: row => {
                return (row.value.substring(0, 25) + (row.value.length > 25 ? '.....' : ''))
            }
        },
        // { header: 'Alamat Ip', id: 'alamat_ip', accessor: 'alamat_ip', child_accessor: null, className: 'text-center'},
        { header: 'Nomor Pemasangan', id: 'nomor_pemasangan', accessor: 'nomor_pemasangan', child_accessor: null, className: 'text-center'},
        { header: 'Max Upload', id: 'max_download', accessor: 'max_download', child_accessor: null,
            Cell: row => {
                return `${row.value} Mbps`;
                }
        },
        { header: 'Max Upload', id: 'max_upload', accessor: 'max_upload', child_accessor: null,
            Cell: row => {
                return `${row.value} Mbps`;
                }
        },
        { header: 'Status', id: 'status', accessor: 'status', child_accessor: null,
            Cell: row => {
                return <span className={(row.value === 'AKTIF') ? 'badge badge-light' : 'badge badge-dark'}>{row.value}</span>
                }
        },
    ],
    }
  }

  componentDidMount(){
      var element = document.getElementById("dashforgejs")
      if (document.getElementById(element))
          document.body.removeChild(element);

      var addScript = document.createElement('script');
      addScript.setAttribute('src', '/assets/js/dashforge.js');
      addScript.setAttribute('id', 'dashforgejs');
          
      document.body.appendChild(addScript);
  }

  render() {
    return (
      <React.Fragment>
          <Sidebar />
          <DataTable 
                columns={this.state.columns} 
                url={this.state.url} 
                title={this.state.title} 
                title_add={this.state.title_add} 
                fields={null} 
                id_pk={null} 
                add_form={false}
                id_pk_column={this.state.id_pk_column}
                style_container="content content-components"
                search_query=""
                search_column={true}
                column_option={false}
                custom_query={'klasifikasi_id='+this.props.data_klasifikasi.klasifikasi_id
                                +'&kategori_id='+this.props.data_klasifikasi.kategori_id
                                +'&sub_klasifikasi_id='+this.props.data_klasifikasi.sub_klasifikasi_id}
          />
          <SectionDataView />
      </React.Fragment>
    );
  }
}


function mapStateToProps(props) {
  return {
      data_klasifikasi : dataStore.getters.getDataKlasifikasi()
  }
}


export default connect(mapStateToProps)(KlasifikasiPekerjaan);
